function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSummaLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M588.4,832.9L588.4,931L84.6,931L84.6,777.9L480.7,686.3L84.6,595.4L84.6,444L588.4,444L588.4,542L247.6,542C237.8,542 224.1,541.9 206.4,541.7C188.7,541.5 175.1,541.4 165.6,541.4L588.4,636.8L588.4,739L165.6,833.7C175.2,833.7 188.8,833.6 206.4,833.4C224.1,833.2 237.8,833.1 247.6,833.1L588.4,833.1L588.4,832.9Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M492.6,92.5L588.6,92.5L588.6,444.5L940.6,444.5L940.6,540.5L588.6,540.5L588.6,892.4L492.6,892.4L492.6,540.4L140.6,540.4L140.6,444.4L492.6,444.4L492.6,92.5Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaLogoWhite);
export default __webpack_public_path__ + "static/media/Summa-logo-white.7628daadd9408f4df7626b802b6dd40d.svg";
export { ForwardRef as ReactComponent };